module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_11.f67ffc32.jpg";